import React from 'react';
import PropTypes from 'prop-types';

import rollbar from '~/src/utilities/libs/rollbar';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './Copy.module.scss';
import i18nStrings from './Copy.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

class Copy extends React.Component {
    copyRef = React.createRef();

    state = {
        failed: false,
        success: false
    };

    onCopyClick = async (event) => {
        try {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(this.props.content);
            } else {
                this.copyRef.current.focus();
                window.document.execCommand('selectAll', false, null);
                window.document.execCommand('copy');
            }

            this.setState({success: true});

            this.props.onCopy && this.props.onCopy();
        } catch (error) {
            rollbar.info(`[Copy] Copying failed: ${error.message}`, error);
            this.setState({failed: true});
        }
    };

    render() {
        return (
            <div className={css.copy} data-testid="CopyElement">
                {this.state.failed && (
                    <div className={css.failed} data-testid="CopyShareNotification">
                        {getTranslation('copyFailed')}
                    </div>
                )}
                {this.state.success && (
                    <div className={css.success} data-testid="CopyShareNotification">
                        {getTranslation('copySuccess')}
                    </div>
                )}

                <div className={css.copyBox}>
                    <div className={css.content} ref={this.copyRef} contentEditable suppressContentEditableWarning data-testid="CopyShareLink">
                        {this.props.content}
                    </div>
                    <button className={css.button} onClick={this.onCopyClick} disabled={this.state.failed} data-testid="CopyShareButton">
                        {getTranslation('copy')}
                    </button>
                </div>
            </div>
        );
    }
}

Copy.propType = {
    content: PropTypes.string.isRequired,
    onCopy: PropTypes.func
};

export default Copy;
